// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__VZF2x","footer":"ModalError_footer__QSKv-"};